import {Component, OnDestroy, OnInit} from '@angular/core';
import {AutoUnsubscribe} from 'ngx-auto-unsubscribe';

@AutoUnsubscribe()
@Component({
  selector: 'student-documents',
  templateUrl: './student-documents.component.html',
  styles: []
})
export class StudentDocumentsComponent implements OnInit, OnDestroy {
  constructor() {
  }

  ngOnInit(): void {
   // initialize stuff
  }

  ngOnDestroy(): void {
    // destroy stuff
  }

}
